// src/controller.mjs
import { parseDateInput, markDateInvalid } from './date-input.mjs';

export class AppController {
  /**
   * @param {AppState} state
   * @param {Calculator} calculator
   * @param {UIManager} ui
   * @param {HTMLCanvasElement} canvas
   */
  constructor(state, calculator, ui, canvas) {
    /** @type {AppState} */
    this.state = state;
    /** @type {Calculator} */
    this.calculator = calculator;
    /** @type {UIManager} */
    this.ui = ui;
    /** @type {HTMLCanvasElement} */
    this.canvas = canvas;
  }

  /**
   * Henter input fra formularen, validerer og tilføjer en ny post til tabellen
   * @returns {void}
   */
  addEntryFromForm() {
    const view = this.ui.view;
    if (!view || !view.dateInput || !view.periodInput || !view.specialInput) return;

    // 1. Træk værdier ud fra UI og transformer dem via forretningslogikken
    const date = parseDateInput(view.dateInput.value);
    const selectIndex = Number(view.periodInput.value);
    const special = Boolean(view.specialInput.checked);

    // 2. Validering
    if (!date || !selectIndex) {
      markDateInvalid(view.dateInput, !date);
      view.dateInput?.focus();
      return;
    }

    // 3. Opdater staten via vores calculator
    this.state.entries.push(
      this.calculator.createEntry(date, selectIndex, special)
    );
    this.state.demoActive = true;

    // 4. Synkroniser brugerfladen
    this.performSync();
    this.ui.clearForm();
  }

  /**
   * Fjerner en specifik post fra tabellen
   * @param {Entry} entry - Den post der skal slettes
   * @returns {void}
   */
  removeEntry(entry) {
    const index = this.state.entries.indexOf(entry);
    if (index === -1) return;

    this.state.entries.splice(index, 1);
    this.state.demoActive = this.state.entries.length > 0;
    
    this.performSync();
  }

  /**
   * Slår demo-tilstand til eller fra
   * @returns {void}
   */
  toggleDemo() {
    if (this.state.demoActive) {
      // Clear all entries while preserving array reference triggers
      this.state.entries.splice(0, this.state.entries.length);
      this.state.demoActive = false;
    } else {
      this.state.entries.push(...this.calculator.createDemoEntries());
      this.state.demoActive = true;
    }
    
    this.performSync();
  }

  /**
   * Centraliseret synkronisering, der binder callbacks og UI sammen
   * @returns {void}
   */
  performSync() {
    const result = this.calculator.calculate(this.state.entries);

    // Vi sender et callback med til removeEntry, så tabellen ved, hvad der skal ske ved sletning
    this.ui.syncView(
        this.state.entries,
        result,
        (entry) => this.removeEntry(entry)
      );
  }
}